import React from "react";

/**
 * ECO Haustechnik — Vector logo
 * Professional technical mark: "eco" with green leaf-styled "o" + small subline "BUILDING TECHNIK"
 */
export default function Logo({ size = "md", className = "" }) {
  const heights = { sm: 32, md: 40, lg: 88 };
  const h = heights[size] || heights.md;

  return (
    <span
      className={`inline-flex items-center leading-none ${className}`}
      aria-label="ECO Haustechnik Logo"
    >
      <svg
        viewBox="0 0 220 120"
        height={h}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        style={{ display: "block" }}
      >
        {/* letter e */}
        <text x="0" y="100" fontFamily="Inter, sans-serif" fontWeight="900" fontSize="118" letterSpacing="-6" fill="#FFFFFF">e</text>
        {/* letter c */}
        <text x="60" y="100" fontFamily="Inter, sans-serif" fontWeight="900" fontSize="118" letterSpacing="-6" fill="#FFFFFF">c</text>
        {/* The "o" — green leaf-styled ring */}
        <g transform="translate(118, 36)">
          <circle cx="34" cy="34" r="30" stroke="#FFFFFF" strokeWidth="11" fill="none" />
          <path
            d="M62 4 C 70 22, 68 42, 54 56 C 40 70, 20 72, 6 66 C 12 50, 22 36, 36 24 C 48 14, 56 8, 62 4 Z"
            fill="#5FA637"
          />
          <path
            d="M58 10 C 46 28, 28 50, 12 64"
            stroke="#0F2A48"
            strokeWidth="2.2"
            strokeLinecap="round"
            fill="none"
            opacity="0.9"
          />
        </g>
      </svg>
    </span>
  );
}
